import { Text } from '@user-portal/wikr-components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { restoreSubscription } from 'store/subscriptions/actions';

import { RESTORE_POPUP_ID } from 'constants/analytics';

import { trackScreenLoad } from 'services/Analytics/trackers/mainTrackers';
import { sendAnalyticRestoreButtonClick } from 'services/Analytics';

import useModals from 'modals/hooks';

import { getCurrenciesSign, getPriceWithDecimals } from 'helpers/prices';
import { ButtonEventAction, CLOSE_EVENT_ACTION, RESTORE_EVENT_ACTION } from './helpers';

import { ModalName } from 'modals/types';

import Modal from 'components/Modal/Modal';
import OutlinedButton from 'components/Buttons/OutlinedButton';
import { CustomPrimaryButton } from 'components/Buttons';

const RestoreSubscriptionModal = () => {
    const { t } = useTranslation();

    const { openModal, closeModal, modalProps } = useModals();

    const dispatch = useDispatch();

    const { id, product, upcoming_product, external_id, subscription_period } = modalProps as ISubscriptionWellfunnel;

    const { currency, amount } = upcoming_product ?? product;

    useEffect(() => {
        trackScreenLoad(RESTORE_POPUP_ID);
    }, []);

    const sendAnalyticsClick = (eventAction: ButtonEventAction) => {
        sendAnalyticRestoreButtonClick(
            'restore_popup',
            {
                subscription_id: external_id,
                period: subscription_period,
                main: `subscription | main | period: ${subscription_period} | price: ${amount}`,
                content_id: id,
            },
            eventAction
        );
    };

    const handleRestore = (eventAction: ButtonEventAction) => {
        sendAnalyticsClick(eventAction);
        dispatch(restoreSubscription(modalProps as ISubscriptionWellfunnel));
        openModal(ModalName.WithLoaderModal, { title: t('basics.loading'), img: null, subtitle: null });
    };

    const handleModalClose = (eventAction: ButtonEventAction) => {
        sendAnalyticsClick(eventAction);
        closeModal();
    };

    return (
        <Modal paddingY={16} isOpen onClose={closeModal} shouldCloseOnOverlayClick>
            <div data-locator="restoreSubModal">
                <Text type="h5" center mb={12}>
                    {t('subscription.restoreModal.title')}
                </Text>
                <Text center color="text-secondary" mb={24}>
                    {t('subscription.restoreModal.subscriptionPeriod', {
                        period: subscription_period,
                        currencySign: getCurrenciesSign(currency),
                        price: getPriceWithDecimals({ price: amount, currency }),
                    })}
                </Text>
                <CustomPrimaryButton
                    dataLocator="restoreBtn"
                    onClick={() => handleRestore(RESTORE_EVENT_ACTION)}
                    mb={20}
                >
                    {t('subscription.restoreModal.restoreButtonText')}
                </CustomPrimaryButton>
                <OutlinedButton
                    dataLocator="cancelBtn"
                    onClick={() => handleModalClose(CLOSE_EVENT_ACTION)}
                    text={t('basics.cancel')}
                    mb={4}
                />
            </div>
        </Modal>
    );
};

export default RestoreSubscriptionModal;
